import { Docs } from "./Docs";
import { WorkspaceJourney } from "@/components/WorkspaceJourney";

/** Staff can edit this public guide through Django site content. */
export function HowTo() {
  return <>
    <div className="mx-auto max-w-7xl px-4 pt-6"><WorkspaceJourney /></div>
    <Docs slug="howto" />
  </>;
}
